<template>
    <fieldset>
        <legend>{{ this.legend }}</legend>
        <slot />
    </fieldset>
</template>

<script>
import framework from '../../framework';
/**
 *  The x-fieldset component.
 *  @module components/x-fieldset
 */


/**
 * The x-fieldset is a fieldset.
 */

export default {
    name: 'x-fieldset',
    props: {
        dataLegend: String,
    },
    mixins: [
        framework.mixins.abstractElement,
    ],
    computed: {
        /**
         * The text for the legend.
         * @returns {string} legend text.
         */
        legend() {
            return this.getAttribute('legend', 'legend');
        },
    },
};
</script>



// WEBPACK FOOTER //
// source/components/x-fieldset/x-fieldset.vue